module.exports = __webpack_public_path__ + "static/media/wishlisticon.ea1ee8d1.svg";